import { render, staticRenderFns } from "./CanteenCreationDialog.vue?vue&type=template&id=d2abd79c&"
import script from "./CanteenCreationDialog.vue?vue&type=script&lang=js&"
export * from "./CanteenCreationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports